import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const InputContainer = styled.div`
	${(props) => props.viewmode && `overflow: auto;`};
	> label {
		display: flex;
	}
`;

export const InputWrapper = styled.div`
	position: relative;
	cursor: pointer;
`;

export const IconContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 4rem;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	body[dir='rtl'] & {
		left: unset;
		right: 0;
	}

	&.deleteIcon {
		left: unset;
		right: 0;

		body[dir='rtl'] & {
			left: 0;
			right: unset;
		}
	}
`;

const FlatpickrInputCss = (props) => css`
	display: ${props.inline ? 'none' : 'block'};
	background-color: var(--input-bg-color);
	color: var(--black);
	font-size: var(--paragraph3-font-size);
	width: 100%;
	padding: var(--inputPadding);
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);
	outline: none;
	padding-left: 4rem;
	min-height: 4.5rem;

	body[dir='rtl'] & {
		padding-left: var(--inputPadding);
		padding-right: 4rem;
		min-height: 5.5rem;
	}

	:hover {
		background-color: var(--table-selected-color);
	}
	:focus {
		background-color: var(--table-selected-color);
		border: 1px solid var(--blue);
	}
	:disabled {
		background-color: var(--input-disabled-bg-color);
		color: var(--content-4);
		-webkit-text-fill-color: var(--content-4);
		opacity: 1;
	}
`;

export const FlatpickrContainer = styled.div`
	&.error > .alt-input {
		border: 1px solid var(--red) !important;
		background-color: var(--red-10) !important;
		color: var(--red) !important;
		box-shadow: 0 0 0 0 !important;
	}

	> .alt-input {
		${(props) => FlatpickrInputCss(props)}
	}
`;

export const FlatpickrTimeContainer = styled.div`
	&.error > .flatpickr-input {
		border: 1px solid var(--red) !important;
		background-color: var(--red-10) !important;
		color: var(--red) !important;
		box-shadow: 0 0 0 0 !important;
	}

	> .flatpickr-input {
		${(props) => FlatpickrInputCss(props)}
	}
`;
